/**
 * Complete theme configuration for ClubOS MSC Academy.
 * Edit only the values below. All functions moved to brandingHelpers.js
 */

// ──────────────────────────────────────────────────────────────────────────────
// ORGANIZATION & BRANDING
// ──────────────────────────────────────────────────────────────────────────────

export const ORGANIZATION = {
  name: "Mohammedan Sporting Club Football Academy",
  tagline: "Youth Development Programme",
  clubNameLine1: "Mohammedan",
  clubNameLine2: "Sporting Club",
};

// ──────────────────────────────────────────────────────────────────────────────
// PRIMARY COLOR PALETTE (base for all theme colors)
// ──────────────────────────────────────────────────────────────────────────────

export const COLORS = {
  primary: {
    hex: "#2e7d52",
    rgb: "46, 125, 82",
  },
  white: "#ffffff",
  black: "#000000",
  lightGray: "#f5f8ff",
};

// ──────────────────────────────────────────────────────────────────────────────
// BACKGROUNDS & GRADIENTS
// ──────────────────────────────────────────────────────────────────────────────

export const BACKGROUNDS = {
  dashboardGradient: "linear-gradient(135deg, #ffffff 0%, #afe6b8 30%, #88bea1 60%, #1a3a2a 100%)",
  sidenavGradient: "linear-gradient(135deg, #1a3a2a 0%, #1e5c3a 30%, #2e7d52 60%, #1a3a2a 100%)",
  menuImage: "/images/loginBack.jpeg",
  menuImageBlur: "3px",
};

// ──────────────────────────────────────────────────────────────────────────────
// TEXT & TYPOGRAPHY
// ──────────────────────────────────────────────────────────────────────────────

export const TYPOGRAPHY = {
  fonts: {
    default: "helvetica",
    heading: "helvetica",
  },
  page: {
    textPrimary: "#ffffff",
    textSecondary: "rgba(255,255,255,0.7)",
    titleColor: "#000000",
    subtitleColor: "rgba(0, 73, 39, 0.85)",
  },
  menu: {
    textColor: "#ffffff",
    sectionTitleColor: "#ffffff",
    brandTextColor: "#ffffff",
    brandFontSize: "1.5rem",
  },
  reportTitle: {
    color: [44, 62, 80],
    fontSize: 12,
  },
  reportMeta: {
    color: 100,
    fontSize: 8,
  },
};

// ──────────────────────────────────────────────────────────────────────────────
// NAVIGATION & MENU STYLING
// ──────────────────────────────────────────────────────────────────────────────

export const MENU = {
  logo: "/images/Athelite-light.png",
  iconActive: {
    background: "#2e7d52",
    foreground: "#ffffff",
  },
  iconInactive: {
    background: "#ffffff",
    foreground: "#2e7d52",
  },
};

// ──────────────────────────────────────────────────────────────────────────────
// SCROLLBAR STYLING
// ──────────────────────────────────────────────────────────────────────────────

export const SCROLLBAR = {
  track: "rgba(255,255,255,0.05)",
  thumb: "rgba(255,255,255,0.25)",
  thumbHover: "rgba(255,255,255,0.45)",
};

// ──────────────────────────────────────────────────────────────────────────────
// LIST & TABLE STYLING
// ──────────────────────────────────────────────────────────────────────────────

export const LIST_COLORS = {
  headerBackground: "#2e7d52",
  headerText: "#ffffff",
  alternatingRowBackground: "#f5f8ff",
  oddRowBackground: "#ffffff",
  evenRowBackground: "rgba(46, 125, 82, 0.02)",
  borderColor: "rgba(46, 125, 82, 0.1)",
  hoverBackground: "rgba(46, 125, 82, 0.05)",
};

// ──────────────────────────────────────────────────────────────────────────────
// PDF REPORT STYLING
// ──────────────────────────────────────────────────────────────────────────────

export const PDF = {
  brandColor: [46, 125, 82],
  accentColor: [245, 248, 255],
  headerTextColor: [255, 255, 255],
  footerLogoSize: 12,
  footerLogoPath: "/images/Mohammedan_SC_logo.svg.png",
  headerBandHeight: 22,
};
